import React from "react";
import { PDFViewer } from "@react-pdf/renderer";

import DocumentTax from "./DocumentTax";

export default function TabPDFTax({ data_pdf }) {
  if (data_pdf == null) {
    return null;
  } else if (data_pdf.hasOwnProperty("tax_data")) {
    return (
      <PDFViewer style={{ flex: 1 }}>
        <DocumentTax data_pdf={data_pdf} />
      </PDFViewer>
    );
  } else {
    return null;
  }
}
